<template>
  <div>
    <form method="POST" class="margin-top-20">
      <input type="hidden" name="_token" :value="csrf">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group" :class="errorFirstName">
            <label class="control-label">First Name</label>
            <dp-input input-type="text" input-name="first_name" :input-value="this.oldData.first_name ? this.oldData.first_name : investor.first_name" v-model="dataModel.first_name"></dp-input>
          </div>
          <div class="form-group" :class="errorLastName">
            <label class="control-label">Last Name</label>
            <dp-input input-type="text" input-name="last_name" :input-value="this.oldData.last_name ? this.oldData.last_name : investor.last_name" v-model="dataModel.last_name"></dp-input>
          </div>
            <div class="form-group" :class="errorEmail">
              <label class="control-label">Email</label>
            <dp-input input-type="email" input-name="email" :input-value="this.oldData.email ? this.oldData.email : investor.email" v-model="dataModel.email"></dp-input>
            </div>
            <div class="form-group" :class="errorCountry">
              <label class="control-label">Country</label>
              <dp-select name="country"
                         :initial-options="countryOptions"
                         :disabled="disableSelect"
                         :select-value="this.oldData.country ? this.oldData.country : this.userData.profile.country"
                         v-model="dataModel.country"
                         @input="onChangeCountry"
                         >
              </dp-select>
            </div>
            <div class="form-group" :class="errorRegion">
              <label class="control-label">{{ regionLabel }}</label>
              <dp-select name="region"
                         :initial-options="regionOptions"
                         :disabled="disableSelect"
                         :select-value="this.regionValue"
                         v-model="dataModel.region">
              </dp-select>
            </div>
          </div>

      </div>

      <div class="form-group" :class="errorInvestorType">
        <label for="investor_type">
          Investor Type
          <modal-help>
            <div class="help-tip-wide">
              <h4>Accredited</h4>
              <ul>
                <li>My income has exceeded $200,000 (or $300,000 with my spouse) in the last two years and it will again this year.</li>
                <li>Either alone or with my spouse, I own more than $1 million in cash and securities, net of associated debt.</li>
                <li>Either alone or with my spouse, I own more than $5 million in net worth.</li>
                <li>I otherwise qualify as an accredited investor.</li>
              </ul>
              <h4 class="margin-top-20">Not Accredited</h4>
              <ul>
                <li>I don't qualify as an accredited investor, but I am interested in investing in opportunities that I can access.</li>
              </ul>
            </div>
          </modal-help>
        </label>
        <div class="padding-left-40">
          <div class="radio radio-primary">
            <input class="form-control" type="radio" name="investor_type" value="accredited" v-model="dataModel.investor_type">
            <label>an Accredited Investor – I meet financial tests or otherwise qualify</label>
          </div>
          <div class="radio radio-primary">
            <input class="form-control" type="radio" name="investor_type" value="eligible" v-model="dataModel.investor_type">
            <label>not an Accredited Investor – I want to invest in opportunities I can access</label>
          </div>
        </div>
      </div>

      <div class="form-group alert alert-info" :class="errorConfirm">
        <label>Confirmation</label>
        <div class="checkbox checkbox-primary">
          <input type="checkbox" class="styled" id="confirm" name="confirm" v-model="dataModel.confirm">
          <label>I confirm that my selection is true.</label>
        </div>
      </div>

      <div class="form-controls">
        <input type="hidden" name="step" value="4">
        <ul class="list-inline">
          <li class="cancel"></li>
          <li class="step-submit"><input type="submit" name="submit" value="Finish" class="btn btn-primary" /></li>
          <li class="step-label"></li>
        </ul>
      </div>
    </form>
  </div>
</template>

<script>
import ModalHelp from "../ModalHelp";
import DpInput from "../forms/DpInput";
import DpSelect from "../forms/DpSelect";

export default {
  name: "UserProfile",
  components: {
    DpSelect,
    DpInput,
    ModalHelp
  },
  props: [
    'userData',
    'countryData',
    'regionData',
    'oldData',
    'errorState'
  ],
  data() {
    return {
      investor: this.userData,
      regionLabel: 'Province',
      regions: [],
      regionOptions: [],
      disableSelect: false,
      regionValue: this.userData.profile.region,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      dataModel: {
        first_name: this.oldData.first_name ? this.oldData.first_name : this.userData.first_name,
        last_name: this.oldData.last_name ? this.oldData.last_name : this.userData.last_name,
        email: this.oldData.email ? this.oldData.email : this.userData.email,
        country: this.oldData.country ? this.oldData.country : this.userData.profile.country,
        region: this.oldData.region ? this.oldData.region : this.userData.profile.region,
        investor_type: this.oldData.investor_type ? this.oldData.investor_type : this.userData.profile.investor_type,
        confirm: this.oldData.confirm ? this.oldData.confirm : this.userData.confirm
      },
      hasErrors: {
        first_name: false,
        last_name: false,
        email: false,
        country: false,
        region: false,
        investor_type: false,
        confirm: false
      }
    }
  },
  methods: {
    checkErrorState() {
      if(this.errorState !== '') {
        if(this.errorState.first_name) {
          this.errorState.first_name.length > 0 ? this.hasErrors.first_name = true : this.hasErrors.first_name = false
        }
        if(this.errorState.last_name) {
          this.errorState.last_name.length > 0 ? this.hasErrors.last_name = true : this.hasErrors.last_name = false
        }
        if(this.errorState.email) {
          this.errorState.email.length > 0 ? this.hasErrors.email = true : this.hasErrors.email = false
        }
        if(this.errorState.country) {
          this.errorState.country.length > 0 ? this.hasErrors.country = true : this.hasErrors.country = false
        }
        if(this.errorState.region) {
          this.errorState.region.length > 0 ? this.hasErrors.region = true : this.hasErrors.region = false
        }
        if(this.errorState.investor_type) {
          this.errorState.investor_type.length > 0 ? this.hasErrors.investor_type = true : this.hasErrors.investor_type = false
        }
        if(this.errorState.confirm) {
          this.errorState.confirm.length > 0 ? this.hasErrors.confirm = true : this.hasErrors.confirm = false
        }
      }
    },
    onChangeCountry(value) {
      switch(value) {
        case 'CA': this.regions = this.regionData.slice(1,14); break
        case 'US': this.regions = this.regionData.slice(15,65); break
        case 'INT': this.regions = this.regionData.slice(66,67); break
        default: this.regions = []
      }
      if(this.userData.profile.country !== value) {
        this.regionValue = ''
      } else {
        this.regions.includes(this.userData.profile.region) ? this.dataModel.region = this.userData.profile.region : this.dataModel.region = ''
        this.dataModel.region === '' ? this.regionValue = '' : this.regionValue = this.userData.profile.region
      }
      this.regionOptions = this.calculateRegionOptions()
    },
    defaultRegions() {
      let country = this.oldData.country ? this.oldData.country : this.userData.profile.country
      switch(country) {
        case 'CA': this.regions = this.regionData.slice(1,14); break
        case 'US': this.regions = this.regionData.slice(15,65); break
        case 'INT': this.regions = this.regionData.slice(66,67); break
        default: this.regions = []
      }
      this.regions.includes(this.userData.profile.region) ? this.dataModel.region = this.userData.profile.region : this.dataModel.region = ''
      this.regionOptions = this.calculateRegionOptions()
    },
    calculateRegionOptions() {
      return this.regions.map((region) => {
        let regionObj = {}
        regionObj.value = region.code
        regionObj.label = region.name
        return regionObj
      })
    },
  },
  computed: {
    countryOptions() {
      return this.countryData.map((country) => {
        let countryObj = {}
        countryObj.value = country.code
        countryObj.label = country.name
        return countryObj
      })
    },
    errorFirstName() {
      if (this.hasErrors.first_name) {
        return 'error'
      }
      return ''
    },
    errorLastName() {
      if (this.hasErrors.last_name) {
        return 'error'
      }
      return ''
    },
    errorEmail() {
      if (this.hasErrors.email) {
        return 'error'
      }
      return ''
    },
    errorCountry() {
      if (this.hasErrors.country) {
        return 'error'
      }
      return ''
    },
    errorRegion() {
      if (this.hasErrors.region) {
        return 'error'
      }
      return ''
    },
    errorInvestorType() {
      if (this.hasErrors.investor_type) {
        return 'error'
      }
      return ''
    },
    errorConfirm() {
      if (this.hasErrors.confirm) {
        return 'error'
      }
      return ''
    }
  },
  created() {
    if(this.oldData.length !== 0) {
      this.dataModel = this.oldData
      this.regionValue = this.oldData.region
    }
    this.checkErrorState()
    this.defaultRegions()
  }
}
</script>